import { Suspense, useCallback, useEffect, useState } from "react";

const useLazyLoad = (options = {}) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [element, setElement] = useState<Element | null>(null);

  const callbackRef = useCallback((node: Element | null) => {
    setElement(node);
  }, []);

  useEffect(() => {
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasLoaded) {
          setIsIntersecting(true);
          setHasLoaded(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: '50px',
        ...options,
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [element, hasLoaded, options]);

  return [callbackRef, isIntersecting, hasLoaded];
};

// Lazy Section Component
const LazySection = ({
  id,
  children,
  formChild,
  fallback = <div style={{ height: formChild?.style?.height ?? '100px', background: 'lightgrey', }} className=""  >Loading...</div>,
  className = "",
}: any) => {
  const [callbackRef, isIntersecting] = useLazyLoad({
    threshold: 0.1,
    rootMargin: '100px'
  });

  return (
    // @ts-ignore
    <div ref={callbackRef} className={className} id={id}>
      {isIntersecting ? (
        <Suspense fallback={fallback}>
          {children}
        </Suspense>
      ) : (
        fallback
      )}
    </div>
  );
};

export default LazySection;